/**
 * TeamSystem Impact - Compliance Path · Brand Background
 *
 * Sfondo a tutta pagina: l'immagine di brand (cerchi concentrici della pagina di
 * login) con un lento "respiro" (zoom in/out), velata da un layer chiaro così da
 * restare delicata e non disturbare la lettura dei contenuti in primo piano.
 */

import { Box, keyframes } from '@mui/material';

const breathe = keyframes`
  0%   { transform: scale(1);    opacity: 0.82; }
  50%  { transform: scale(1.18); opacity: 1;    }
  100% { transform: scale(1);    opacity: 0.82; }
`;

/**
 * Da posizionare come primo figlio di un contenitore con position: relative.
 * Copre tutta l'area (position: absolute, inset: 0).
 */
export const BrandScene = () => (
  <Box aria-hidden sx={{ position: 'absolute', inset: 0, overflow: 'hidden', zIndex: 0, pointerEvents: 'none' }}>
    {/* Immagine di brand con respiro */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'url(/login-bg.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        animation: `${breathe} 10s ease-in-out infinite`,
        '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      }}
    />
    {/* Velo chiaro: schiarisce l'immagine per non renderla fastidiosa */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        backgroundColor: 'rgba(255, 255, 255, 0.84)',
      }}
    />
  </Box>
);
